import GeneralForm from "components/GeneralForm"
import { validate } from "components/validateGeneralForm"
import { useEffect, useMemo, useState } from "react"
import { Button, Modal, ModalBody } from "reactstrap"

export default function ModalGrupo({ config, onClosed, onSave }) {
  const [data, setData] = useState({})

  const formConfig = useMemo(() => {
    if (!config)
      return []

    return [
      [
        {
          name: 'where',
          type: 'view',
          component: () => {
            return (
              <>
                <label>Criar abaixo de</label>
                <div className="mb-4 form-control" style={{ height: 'auto' }}>{config.pai.descricao}</div>
              </>
            )
          },
        },
        { name: "codigo", label: 'Código', type: "text", required: true, colspan: 6, disabled: config.modo == 'edit' },
        { name: "descricao", label: 'Descrição', type: "text", required: true, colspan: 12 },
      ]
    ]
  }, [config])

  useEffect(() => {
    if (config?.modo == 'edit')
      setData(config.data)
    else
      setData({})
  }, [config])

  const handleChange = (name, value) => {
    setData({ ...data, [name]: value })
  }

  const handleSubmit = e => {
    e.preventDefault()

    const errors = validate(formConfig, data)
    if (errors.length > 0) {
      setData({ ...data, errors })
      // erros foram encontrados
      return
    }

    onSave && onSave(config.pai.id, config.modo, config.id, data)
  }

  return (
    <Modal isOpen={!!config} onClosed={onClosed} size="lg">
      <ModalBody>
        {config && (
          <>
            <h2>Cadastro de Grupo</h2>
            <hr />
            <form onSubmit={handleSubmit}>
              <GeneralForm
                data={data}
                onChange={handleChange}
                config={formConfig} />
              <div className="text-right">
                <Button type="submit" color="primary">Salvar</Button>
                <Button type="button" onClick={onClosed} color="secondary">Cancelar</Button>
              </div>
            </form>
          </>
        )}
      </ModalBody>
    </Modal>
  )
}